module.exports = __webpack_public_path__ + "img/menu-blanco.b60bdcf6.svg";